(function ($) {
    $.fn.collapse = function () {
        var $self = $(this);
        var $wrapper = $self.find('.js-collapse-wrapper');
        var $content = $self.find('.js-collapse-content');
        var $button = $self.find('.js-collapse-button');
        var contentHeight = parseInt($content.css('height'));
        var wrapperHeight = parseInt($wrapper.css('height'));
        var $cup = $self.find('.js-collapse-cup');
        var classHidden = 'hidden';

        /**
         * скрытие кнопок, если контента мало
         */
        var hideButton = function () {
            if (contentHeight < wrapperHeight) {
                $button.addClass(classHidden);
                if ($cup) {
                    $cup.addClass(classHidden);
                }
            }
        };
        /**
         * инициализация
         */
        var init = function () {
            hideButton();
            $button.on('click', function () {
                contentHeight = parseInt($(this).closest('.js-collapse').find('.js-collapse-content').css('height'));

                if (contentHeight > wrapperHeight) {
                    if ($self.hasClass('active')) {
                        closeContent();
                        $self.toggleClass('active');
                        return;
                    }

                    $self.toggleClass('active');
                    openContent();
                }
            });
        };
        /**
         * открытие контента
         */
        var openContent = function () {
                $wrapper.css('height', contentHeight);
        };
        /**
         * скрытие контента
         */
        var closeContent = function () {
            $wrapper.css('height', wrapperHeight);
        };

        init();

        return this;
    };

    $('.js-collapse').each(function () {
        $(this).data('collapse', $(this).collapse());
    });
})(jQuery);
